
import React from 'react'
import { FormLabel, RadioGroup, FormControlLabel, Radio, TextField, Typography, TextareaAutosize, Button } from '@mui/material'
import Upload from '../Component/Upload';

const Doctorform = () => {
  return (
    <>
    <div className='doctor-form'>
        <form>
            <div className='form-field'>
                <TextField label="Search Input" type='search'  variant='outlined' fullWidth />
            </div>
            <div className='form-field'>
                <TextField label="Doctor Name" type='text' value='Rohan Sharma' variant='outlined' fullWidth />
                <TextField label="Patient Name" type='text' value='Mohan Shukla' variant='outlined' fullWidth />
            </div>
           <div className='form-field'>
                
                <textarea placeholder='Message' variant='outlined' fullWidth  />
            </div>
           <div className='form-field'>
               <TextField label="Age" type='number' variant='outlined' size='medium' />
                <div className='radio-filed'>
                    <RadioGroup row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                >
                <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                <FormControlLabel value="female" control={<Radio />} label="Female" />
                <FormControlLabel value="male" control={<Radio />} label="Male" />
                <FormControlLabel value="other" control={<Radio />} label="Other" />
               
                    </RadioGroup>
                </div>
            </div>
            
            <div className='form-field'>
                <Upload />
            </div>
            <Button variant="contained" >Submit</Button>
        </form>
    </div>
    
    </>
  )
}

export default Doctorform

